import { FC } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import CustomBody from "../../CustomBody/index";
import { CustomButton } from "../../../../Forms";
import DateCard from "./DateCard";
import Timeslot from "./Timeslot";

//Assets
import ScheduledIcon from "../../../../../images/scheduled.png";

//Interface
import { DropoffScheduleInterface } from "../definitions";

const DropoffSchedule: FC<DropoffScheduleInterface> = ({ 
  loading,
  selectedScheduled,
  selectedDate,
  scheduledList,
  setSelectedDate,
  setDropoffScheduled,
  setSelectedScheduled
}): JSX.Element => {
  return (
    <CustomBody loading={loading} withBack backAction={() => setDropoffScheduled(false)}>
      <div className="drop-off-scheduled-body">
        <KickImage src={ScheduledIcon} alt="scheduled" className="scheduled-icon" />
        <p className="header">Set Self Drop-off Schedule</p>
        <p className="info info-one">Please follow the time slots available below, any appointments <br /> outside the time schedule will not be responded.</p>
        <p className="info info-two">Reminder: Make sure you have the ORDER ID attached to your <br /> package for us to identify your account and status.</p>
        <DateCard 
          scheduledList={scheduledList}
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
        />
        <Timeslot 
          selectedDate={selectedDate}
          selectedScheduled={selectedScheduled}
          setSelectedScheduled={setSelectedScheduled}
        />
        <CustomButton
          text={"Confirm"}
          disabled={!selectedScheduled.start_time}
          onClick={() => setDropoffScheduled(false)}
        />
      </div>
    </CustomBody>
  )
}

export default DropoffSchedule;